import { db } from "@/firebase";
/* eslint-disable */
export default {
  firebase() {
    return {
      languagesObject: {
        source: db.ref(`hotels/${this.$customerId}/${this.$hotelId}/hotelLanguages`),
        readyCallback: (response) => {
          // const data = response.val();
          // const languages = [...new Set([
          //   ...data.languages.map((language) => language.countryCode),
          //   ...data.languageTypes
          // ])];

          this.languageTypes.push({
            index: 0,
            native: 'GB'
          });
          // Update languageTypes to object with native names
          // languages.forEach((type, index) => {
          //   const tempObject = {
          //     index,
          //     type
          //   };

          //   // Get native language name
          //   this.$http
          //     .get(
          //       `https://restcountries.eu/rest/v2/alpha/${type}?fields=languages`
          //     )
          //     .then((response) => {
          //       const nativeName = response.data.languages[0].nativeName;

          //       this.languageTypes.push({
          //         ...tempObject,
          //         // Api for PH returns English as native language  or
          //         // Capitalise native name (API error with "Dansk" returning as "dansk")
          //         native: type === 'PH' ? 'Tagalog' : `${nativeName.charAt(0).toUpperCase()}${nativeName.slice(1).toLowerCase()}`
          //       });
          //     })
          //     .catch(() => {
          //       this.languageTypes.push({
          //         ...tempObject,
          //         // Save type as native for display on error
          //         native: type
          //       });
          //     });
          // });
        },
      },
    };
  },
};
